<api-call-gate [apiCall]="coilHistoryEndpoint">
  <ng-template #lastSuccessfulData>
    <!-- Phones view -->
    <ng-container *ngIf="screenLayoutService.phone$ | async; else desktopView">
      <div class="full-week-container">
        <div class="full-week">
          <div
            *ngFor="let item of fullWeekWithStatusCount$ | async; let i = index"
            class="bigger-circles-phone"
            [ngStyle]="resizeGreyCirclePhone(item)"
            (click)="setFilteredEntries(item)"
            (keydown)="setFilteredEntries(item)"
            tabindex="0"
          >
            <sh-icon
              class="icon-phone"
              size="m"
              *ngIf="setDateIcon(item.stateIconColor)"
              [icon]="setDateIcon(item.stateIconColor)"
            ></sh-icon>
            <div
              class="day-of-week-phone"
              tabindex="0"
              (click)="setFilteredEntries(item)"
              (keydown)="setFilteredEntries(item)"
            >
              <span>{{ item.dayOfWeek }},&nbsp; </span>
              <span>{{ item.calDay | localizedDate }}</span>
              <span class="status-count" *ngIf="item.statusCount > 0">
                &nbsp;({{ item.statusCount }})</span
              >
              <sh-icon [icon]="'arrow-line-right-s'"></sh-icon>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Desktops/Tablets/Laptops view -->
    <ng-template #desktopView>
      <section class="dates-grid">
        <!-- any element to occupy a cell -->
        <br />
        <div
          *ngFor="let item of firstWeek$ | async; let i = index"
          class="day-of-month"
          [ngStyle]="setGreyCircleColor(item)"
        >
          <div class="day-of-week">
            <span> {{ item.dayOfWeek }} </span>
          </div>
          <div class="date-with-icon">
            <sh-icon
              size="xs"
              *ngIf="setDateIcon(item.stateIconColor)"
              [icon]="setDateIcon(item.stateIconColor)"
            ></sh-icon>
            <div>{{ item.calDayOnly }}</div>
          </div>
        </div>

        <!-- Call gate first week -->
        <api-call-gate
          class="channel-api-call"
          loadingLabel="Loading coil channel data..."
          [apiCall]="coilChannelHistoryEndpoint"
        >
          <ng-template #lastSuccessfulData *ngIf="showExpandedChannels">
            <ng-container *ngIf="sliceFirstWeekChannel$ | async as channels">
              <ng-container *ngFor="let coil of channels; let i = index">
                <sh-text
                  size="body-2"
                  color="secondary"
                  class="coil-element-text"
                  [ngClass]="{ 'last-row': i === channels.length - 1 }"
                  >{{ coil.coilElement }}</sh-text
                >
                <div *ngFor="let color of coil.coilChannelHistory">
                  <div
                    class="colored-circles"
                    [ngStyle]="resizeGreyCircleDefault(color)"
                  >
                    <sh-icon
                      size="xs"
                      style="color: white"
                      *ngIf="setDateIcon(color.stateIconColor)"
                      [icon]="setDateIcon(color.stateIconColor)"
                    ></sh-icon>
                  </div>
                </div>
              </ng-container>
            </ng-container>
            <sh-text
              (click)="
                toggleFirstWeekChannelData(); toggleChannelsText('upper')
              "
              color="primary"
              class="show-more-channels-row"
              *ngIf="(coilChannelHistory$ | async)?.length >= 5"
            >
              {{
                (coilChannelHistory$ | async)?.length -
                  this.initialChannelLength
              }}
              {{ upperChannelText$ | async }}
              <sh-icon
                [icon]="
                  upperMoreChannelsArrowIcon
                    ? 'arrow-line-down-s'
                    : 'arrow-line-up-s'
                "
              ></sh-icon>
            </sh-text>
          </ng-template>
        </api-call-gate>

        <br />

        <div
          *ngFor="let item of secondWeek$ | async; let i = index"
          class="day-of-month"
          [ngStyle]="setGreyCircleColor(item)"
        >
          <div class="day-of-week">
            <span
              *ngIf="
                showExpandedChannels || (screenLayoutService.phone$ | async)
              "
            >
              {{ item.dayOfWeek }}
            </span>
          </div>
          <div class="date-with-icon">
            <sh-icon
              size="xs"
              *ngIf="setDateIcon(item.stateIconColor)"
              [icon]="setDateIcon(item.stateIconColor)"
            ></sh-icon>
            <div>{{ item.calDayOnly }}</div>
          </div>
        </div>

        <!-- Call gate second week -->
        <api-call-gate
          class="channel-api-call"
          loadingLabel="Loading coil channel data..."
          [apiCall]="coilChannelHistoryEndpoint"
        >
          <ng-template #lastSuccessfulData *ngIf="showExpandedChannels">
            <ng-container *ngIf="sliceSecondWeekChannel$ | async as channels">
              <ng-container *ngFor="let coil of channels; let i = index">
                <sh-text
                  size="body-2"
                  color="secondary"
                  class="coil-element-text"
                  [ngClass]="{ 'last-row': i === channels.length - 1 }"
                  >{{ coil.coilElement }}</sh-text
                >
                <div *ngFor="let color of coil.coilChannelHistory">
                  <div
                    class="colored-circles"
                    [ngStyle]="resizeGreyCircleDefault(color)"
                  >
                    <sh-icon
                      size="xs"
                      style="color: white"
                      *ngIf="setDateIcon(color.stateIconColor)"
                      [icon]="setDateIcon(color.stateIconColor)"
                    ></sh-icon>
                  </div>
                </div>
              </ng-container>
            </ng-container>
            <sh-text
              *ngIf="
                showExpandedChannels &&
                (coilChannelHistory$ | async)?.length >= 5
              "
              (click)="
                toggleSecondWeekChannelData(); toggleChannelsText('lower')
              "
              color="primary"
              class="show-more-channels-row"
              >{{
                (coilChannelHistory$ | async)?.length -
                  this.initialChannelLength
              }}
              {{ lowerChannelText$ | async }}
              <sh-icon
                [icon]="
                  lowerMoreChannelsArrowIcon
                    ? 'arrow-line-down-s'
                    : 'arrow-line-up-s'
                "
              ></sh-icon>
            </sh-text>
          </ng-template>
        </api-call-gate>
      </section>
    </ng-template>
  </ng-template>
</api-call-gate>
